module.exports = __webpack_public_path__ + "img/left.354965ae.svg";